// eslint-disable-next-line import/prefer-default-export
export const removeEnd = (word, wordToRemoveAtEnd) => word.substring(0, word.length - wordToRemoveAtEnd.length);
